<template>
  <MainLayout fluid>
      <BatchesTable />
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/Main'
import ItemTableTemplate from '@/components/ItemTableTemplate'
import ItemTable from '@/components/ItemTable'
import Batch from '@/resources/Batch'

const BatchesTable = {
  ...ItemTableTemplate,
  mixins: [ItemTable(Batch)]
}

export default {
  components: { MainLayout, BatchesTable },
  metaInfo() {
    return {
      title: this.$t('batches.title'),
    }
  },
};
</script>